<div class="row">
  <div class="col-12 text-center">
    <a class="button" routerLink="/register/create">
      <img src="assets/images/tempThaiD.png" class="img">
    </a>
  </div>
</div>
